import { MdOutlineCheckCircle, MdOutlineCancel, MdOutlinePending, MdOutlineRadioButtonUnchecked } from 'react-icons/md';
import NewTooltip from '../../atoms/NewTooltip';

interface CheckIndicatorProps {
    received: boolean;
    status?: string;
    receivedTooltip?: string;
    notReceivedTooltip?: string;
    statusTooltips?: Record<string, string>;
}

const STATUS_ICON: Record<string, { icon: typeof MdOutlineCheckCircle; color: string }> = {
    VALIDATED: { icon: MdOutlineCheckCircle, color: 'text-green-500' },
    CONFIRMED: { icon: MdOutlineCheckCircle, color: 'text-green-500' },
    PARTIALLY_CONFIRMED: { icon: MdOutlineCheckCircle, color: 'text-orange-500' },
    VERIFIED: { icon: MdOutlineCheckCircle, color: 'text-green-500' },
    REJECTED: { icon: MdOutlineCancel, color: 'text-red-500' },
    NOT_CONFIRMED: { icon: MdOutlineCancel, color: 'text-red-500' },
    IN_PROGRESS: { icon: MdOutlinePending, color: 'text-yellow-500' },
};

const CheckIndicator = ({ received, status, receivedTooltip, notReceivedTooltip, statusTooltips }: CheckIndicatorProps) => {
    const topIcon = received
        ? <MdOutlineCheckCircle className="text-green-400" size={10} />
        : <MdOutlineRadioButtonUnchecked className="text-gray-300" size={10} />;

    const { icon: BottomIcon, color } = STATUS_ICON[status || ''] || { icon: MdOutlinePending, color: 'text-amber-500' };
    const bottomIcon = received
        ? <BottomIcon className={color} size={14} />
        : <MdOutlineRadioButtonUnchecked className="text-gray-300" size={14} />;

    const topTooltip = received ? (receivedTooltip || 'Recebido') : (notReceivedTooltip || 'Não recebido');
    const bottomTooltip = statusTooltips?.[status || ''] || status || 'Pendente';

    return (
        <div className="flex flex-col items-center gap-0.5">
            <NewTooltip content={topTooltip} alignment="top">{topIcon}</NewTooltip>
            <NewTooltip content={bottomTooltip} alignment="top">{bottomIcon}</NewTooltip>
        </div>
    );
};

export default CheckIndicator;
